export const FOLDER_SEPARATOR = ' / ';
export const COLLAPSE_INDICATOR = '...';
export const COLLAPSE_THRESHOLD_MULTIPLICATOR = 1.5;